<template>
  <div class="qa-list">
    <Header title="电子保单" :leftHandler="leftHandler"></Header>
    <div v-if="isWholesaler" class="tips" @click="tips">审批说明 <van-icon name="label-o" style="margin-right:5px" />
    </div>
    <div class="search-box">
      <van-dropdown-menu class="searchType" active-color="#117281">
        <van-dropdown-item v-model="searchType" :options="isWholesaler ? option2 : option1" @change="clearInput()" />
      </van-dropdown-menu>
      <van-search class="search" v-model="value" show-action placeholder="请输入搜索关键词" @search="onSearch">
        <template #action>
          <div style="font-size:15px" @click="init(false, true)">搜索</div>
        </template>
      </van-search>
    </div>

    <div class="info-list">
      <van-tabs v-if="!isWholesaler" class="tabs" v-model="active" :ellipsis="false" color="#117281" @click="init(true)"
        swipeable>
        <van-tab v-for="(item, index) in tabList1" :title="item.title" :name="item.name" :key="index">
          <!-- <van-loading class="loading" size="35px" color="#117281"  v-show="loading"/> -->
          <van-loading class="loading" size="35px" color="#117281" v-show="loading" />
          <div v-if="noData" class="noData">暂无数据</div>
          <van-list v-else v-model="Listloading" :finished="finished" offset="30" :immediate-check="false" @load="onLoad(true)" class="qa-list">
            <div class="qa-item" v-for="(item, index) of qaList" @click="gotoWeb(item.warrantyId)"
              :key="item.partNo + index">
              <div class="item-img"><img :src="item.partImageUrl" alt=""></div>
              <div class="item-info">
                <div class="item-title"><span>{{ item.partName }} </span>{{ item.partNo }}</div>
                <div class="item-warrantyCode">{{ item.warrantyCode }}</div>
                <!-- <div class="item-mobile" v-if="item.consumerMobile">{{ item.consumerMobile }}</div> -->
                <div class="item-info-base">
                  <div :class="'status-' + item.warrantyStatus" class='item-status'>
                    {{ getItemStatus(item.warrantyStatus) }}
                    <span v-if="item.warrantyStatus === 4">经销商{{ item.verifyStatus }}</span>
                  </div>
                  <!-- <div class="item-date">{{ parseTime(item.initTime, '{y}-{m}-{d}') }}</div> -->
                </div>
              </div>
            </div>
            <div style="height:60px"></div>
          </van-list>
          <div class="footer">
            <!-- <div  class="btn scan-btn" @click="scanCode('feedback')">扫码质保核验</div> -->
            <div class="btn scan-btn" @click="scanCode()">扫码添加保单</div>
          </div>
        </van-tab>
      </van-tabs>

      <div v-else class="agency">
        <van-dropdown-menu class="status-select" active-color="#117281">
          <van-dropdown-item v-model="statusType" :options="option3" @change="init(false, false, true)" />
        </van-dropdown-menu>
        <van-tabs v-if="statusType === 4" class="tabs" v-model="verifyStatus" :ellipsis="false" color="#117281"
          @click="init(false, false, true)" swipeable>
          <van-tab v-for="(item, index) in tabList2" :title="item.title" :name="item.name" :key="index">
            <!-- <van-loading class="loading" size="35px" color="#117281"  v-show="loading"/> -->
            <van-loading class="loading" size="35px" color="#117281" v-show="loading" />
            <div v-if="noData" class="noData">暂无数据</div>
            <van-list v-else v-model="Listloading" :finished="finished" offset="30" :immediate-check="false" @load="onLoad(false, false, true)"
              class="qa-list">
              <div class="qa-item" v-for="(item, index) of qaList" @click="gotoWeb(item.warrantyId, true)"
                :key="item.partNo + index">
                <div class="item-img"><img :src="item.partImageUrl" alt="">
                  <button v-if="verifyStatus == '02' && item.boschVerifyStatus == '03'" @click.stop="cause(item)"
                    style="color:#fb5465 ;background-color: #de868f4b;" class="button">博世审批拒绝 <van-icon
                      name="question-o" /> </button>
                  <button v-if="verifyStatus == '02' && item.boschVerifyStatus == '01'"
                    style="color: #696969 ;background-color: #bebebe3f;" class="button"> 待博世审批 </button>
                  <button v-if="verifyStatus == '02' && item.boschVerifyStatus == '02'" @click.stop="cause(item)"
                    style="color: #299ea0 ;background-color: #54bbbd50;" class="button">博世审批通过<van-icon
                      v-if="item.boschVerifyDesc !== ''" name="question-o" /></button>
                </div>
                <div class="item-info">
                  <div class="item-title"><span>{{ item.partName }} </span>{{ item.partNo }}</div>
                  <div class="item-warrantyCode">{{ item.warrantyCode }}</div>
                  <!-- <div class="item-mobile" v-if="item.consumerMobile">{{ item.consumerMobile }}</div> -->
                  <div class="item-info-base">
                    <div :class="'status-' + item.warrantyStatus" class='item-status'>
                      <!-- {{ getItemStatus(item.warrantyStatus) }} -->
                      <span v-if="item.verifyStatus">经销商{{ item.verifyStatus }}</span>
                    </div>
                    <!-- <div class="item-date">{{ parseTime(item.initTime, '{y}-{m}-{d}') }}</div> -->
                  </div>
                </div>
              </div>
              <div style="height:60px"></div>
            </van-list>
            <div class="footer">
              <div class="btn scan-btn" @click="scanCode('', true)">扫码查看保单</div>
            </div>
          </van-tab>
        </van-tabs>
        <div v-else class="agency-list">
          <van-loading class="loading" size="35px" color="#117281" v-show="loading" />
          <div v-if="noData" class="noData">暂无数据</div>
          <van-list v-else v-model="Listloading" :finished="finished" offset="30" :immediate-check="false" @load="onLoad(false ,false,true)" class="qa-list">
            <div class="qa-item" v-for="(item, index) of qaList" @click="gotoWeb(item.warrantyId, true)"
              :key="item.partNo + index">
              <div class="item-img"><img :src="item.partImageUrl" alt=""></div>
              <div class="item-info">
                <div class="item-title"><span>{{ item.partName }} </span>{{ item.partNo }}</div>
                <div class="item-warrantyCode">{{ item.warrantyCode }}</div>
                <!-- <div class="item-mobile" v-if="item.consumerMobile">{{ item.consumerMobile }}</div> -->
                <div class="item-info-base">
                  <div :class="'status-' + item.warrantyStatus" class='item-status'>
                    {{ getItemStatus(item.warrantyStatus) }}
                    <span v-if="item.verifyStatus">经销商{{ item.verifyStatus }}</span>
                  </div>
                  <!-- <div class="item-date">{{ parseTime(item.initTime, '{y}-{m}-{d}') }}</div> -->
                </div>
              </div>
            </div>
            <div style="height:60px"></div>
          </van-list>
          <div class="footer">
            <div class="btn scan-btn" @click="scanCode('', true)">扫码查看保单</div>
          </div>
        </div>
      </div>
    </div>

    <!-- <van-popup v-model="showTrayCode" position="bottom" class="trayInfo-pop" >
      <div class="title-pop">扫码结果</div>
    <div class="result-info">
      <div class="icon-bg">
        !
      </div>
      <div class="result-info-text">
        <span v-if="trayCodeType==='1'">中箱码</span>
        <span v-if="trayCodeType==='9'">托盘码</span>
        <span v-if="trayCodeType!=='9'&&trayCodeType!=='1'">托盘码/中箱码</span>
      </div>
      <div class="result-info-text2">
        仅限信息查询
      </div>
    </div>
    <div class="info">
      <div class="info-item">
        <div class="title">产品名称</div>
        <div class="text">{{trayInfo.productName}}</div>
      </div>
      <div class="info-item">
        <div class="title">产品料号</div>
        <div class="text">{{trayInfo.partNo}}</div>
      </div>
      <div class="info-item">
        <div class="title">数量</div>
        <div class="text">{{trayInfo.partQty}}</div>
      </div>
      <div class="info-item">
        <div class="title">工厂</div>
        <div class="text">{{trayInfo.factoryInfo}}</div>
      </div>
      <div class="info-item">
        <div class="title">经销商</div>
        <div class="text">{{trayInfo.wholesalerInfo}}</div>
      </div>
    </div>

    </van-popup> -->

    <quality-assurance-tray-info v-if="showTrayCode" :trayInfo="trayInfo"
      :showTrayInfo="showTrayInfo"></quality-assurance-tray-info>
    <van-dialog v-model="show" :title="dialog.title" confirmButtonText='我知道了' confirmButtonColor='#117281'>
      <div slots="default" class="default-tips">
        {{ boschVerifyDesc }}
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Header from '../../../components/header.vue'
import activityApi from '@/api/activity.js'
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import { Dialog } from 'vant'
import QualityAssuranceTrayInfo from '../2022/components/quality-assurance-tray-info.vue'

export default {
  components: { Header, QualityAssuranceTrayInfo },
  data () {
    return {
      value: '',
      boschVerifyDesc: '',
      show: false,
      qaList: {},
      loading: true,
      showTrayCode: false,
      showTrayInfo: true,
      trayInfo: {},
      trayCodeType: '',
      tabList1: [{ name: 0, title: '全部保单' },
        { name: 1, title: '销售方激活' },
        { name: 3, title: '车主已领取' },
        { name: 4, title: '质保已提交' },
        { name: 5, title: '已失效' }],
      tabList2: [{ name: '01', title: '我的待审核' },
        { name: '02', title: '我的审批通过' },
        { name: '03', title: '我的审批拒绝' },
        { name: '04', title: '我的审批驳回' }],
      active: 0,
      option1: [
        { value: 'partNo', text: '配件编码' },
        { value: 'partName', text: '配件名称' },
        { value: 'warrantyCode', text: '质保单编号' },
        { value: 'consumerMobile', text: '车主手机号' }
      ],
      option2: [
        { value: 'partNo', text: '配件编码' },
        { value: 'partName', text: '配件名称' },
        { value: 'warrantyCode', text: '质保单编号' },
        { value: 'consumerMobile', text: '车主手机号' },
        { value: 'workshopName', text: '修理厂名称' }
      ],
      option3: [
        { value: 0, text: '全部保单' },
        { value: 1, text: '销售方激活' },
        { value: 3, text: '车主已领取' },
        { value: 4, text: '质保已提交' },
        { value: 5, text: '已失效' }
      ],
      searchType: 'partNo',
      isSearch: false,
      noData: false,
      isWholesaler: false,
      statusType: 4,
      verifyStatus: '01',
      finished: false,
      Listloading: false,
      page: 1,
      dialog: {
        title: ''
      }
    }
  },
  created () {
    let clientInfo = userUtils.getClientInfo()
    if (clientInfo.channelCode.startsWith('11')) {
      this.isWholesaler = true
    }
    console.log(this.clientInfo)
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })
    this.init(false, false, this.isWholesaler)
  },
  mounted () {
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    console.log('isIOS', isIOS)
    if (isIOS && location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
  },
  watch: {
    'active' () {
      if (!this.isSearch || (this.active === 1 && this.isSearch)) {
        this.page = 1
        this.finished = false
        this.init(true)
        this.isSearch = false
      } else {
        this.page = 1
        this.finished = false
        this.isSearch = false
      }
    }
  },
  methods: {
    parseTime: commonUtils.parseTime,
    init (isTab, isSearch, isAgency) {
      this.finished = false
      this.page = 1
      let params = {
        page: 1,
        pageSize: 5
      }
      if (isTab === true) {
        params = {
          warrantyStatus: this.active || '',
          page: 1,
          pageSize: 5
        }
      } else if (isSearch) {
        if (!this.value) {
          this.$toast('请输入搜索关键字')
          return
        }
        params = {
          [this.searchType]: this.value,
          page: 1,
          pageSize: 5
        }
      } else if (isAgency) {
        params = {
          warrantyStatus: this.statusType || '',
          verifyStatus: this.statusType === 4 ? this.verifyStatus : '',
          page: 1,
          pageSize: 5
        }
      }
      activityApi.qualityAssuranceWsList(params).then((res) => {
        if (res.data.resultCode === '0') {
          if (res.data.resultData.warrantyList.length === 0) {
            this.noData = true
          } else {
            this.noData = false
          }
          this.qaList = res.data.resultData.warrantyList
          if (isSearch) {
            this.active = 0
            this.statusType = 0
            this.isSearch = true
          }
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 审核说明提示弹窗
    tips () {
      Dialog.alert({
        title: '审批说明',
        message: '您审批通过的电子保单将由博世工作人员再次审批（3个工作日内），以核对质保。',
        confirmButtonText: '我知道了',
        confirmButtonColor: '#117281'
      }).then(() => {
        // on close
      })
    },
    // 下滑刷新
    onLoad (isTab, isSearch, isAgency) {
      let page = this.page + 1
      let params = {
        page: page,
        pageSize: 5
      }
      if (isTab === true) {
        if (this.active === '') {
          params = {
            warrantyStatus: this.statusType || '',
            page: page,
            pageSize: 5
          }
        } else {
          params = {
            warrantyStatus: this.active || '',
            page: page,
            pageSize: 5
          }
        }
      } else if (isSearch) {
        params = {
          [this.searchType]: this.value,
          page: page,
          pageSize: 5
        }
      } else if (isAgency) {
        params = {
          warrantyStatus: this.statusType || '',
          verifyStatus: this.statusType === 4 ? this.verifyStatus : '',
          page: page,
          pageSize: 5
        }
      }
      activityApi.qualityAssuranceWsList(params).then((res) => {
        if (res.data.resultCode === '0') {
          let itemList = res.data.resultData.warrantyList
          this.qaList = this.qaList.concat(itemList)
          this.Listloading = false
          this.page++
          if (res.data.resultData.warrantyList < 3) {
            this.finished = true
          }
        }
      }).catch(() => {
        this.Listloading = false
      })
    },
    cause (item) {
      if (item.boschVerifyDesc === '') {
        return
      }
      if (item.boschVerifyStatus === '02') {
        this.dialog.title = '博世审批通过原因'
      } else {
        this.dialog.title = '博世审批拒绝原因'
      }
      this.boschVerifyDesc = item.boschVerifyDesc
      this.show = true
    },
    clearInput () {
      this.value = ''
      // this.init()
    },
    onSearch () { },
    gotoWeb (id, isAgency) {
      if (isAgency) {
        this.$router.push({ name: 'quality-assurance-agency-detail', query: { warrantyId: id, type: 'info' } })
      } else {
        this.$router.push({ name: 'quality-assurance-ws-feedback', query: { warrantyId: id, type: 'info' } })
      }
    },

    leftHandler () {
      this.$router.push({ name: 'center' })
    },
    getItemStatus (status) {
      switch (status) {
        case 1:
          return '销售方激活'
        case 2:
          return '车主未领取'
        case 3:
          return '车主已领取'
        case 4:
          return ''
        case 5:
          return '已失效'
        default:
          break
      }
    },
    // 扫码
    scanCode (type, isAgency) {
      // 测试
      // let code = {
      //   // warrantyCode: '16413693403640092S47338'
      //   // scanCode: 'https://qr.bosch-extra.com.cn:8443/5e61ec0b-f1f2-4ea8-bc6a-4c1a1450aaa4'
      //   //scanCode: 'https://rbaasc.uxicp.com/0092S47338WRE_1_000020211230120902_97955781_02'
      //    scanCode: 'http://qr.boschaa.com/632b1469-aab6-4c66-9cc4-013e0ad7fbae'
      //   // scanCode: 'http://sqr.bosch-extra.com.cn/0092S47323WRE_9_20220222033504047_97955781_10'
      // }
      // this.scanResult(code, type, isAgency)
      // return 0

      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          let scanData
          if (isAgency) {
            scanData = {
              scanCode: res.resultStr
            }
            this.scanResult(scanData, '', isAgency)
          } else {
            if (type === 'feedback') {
              scanData = {
                warrantyCode: res.resultStr
              }
              this.scanResult(scanData, 'feedback')
            } else {
              scanData = {
                scanCode: res.resultStr
              }
              this.getLocation(scanData)
            }
          }
        },
        fail: res => {
          this.$toast('调用扫码功能异常')
          console.log('fail', res)
        },
        cancel: function () {
          this.$router.push({ name: 'gbb-qrCode-scan' })
          console.log('scan cancel')
        }
      })
    },

    // 获取经纬度
    getLocation (scanData) {
      this.$wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          scanData.locLat = res.latitude // 纬度，浮点数，范围为90 ~ -90
          scanData.locLong = res.longitude // 经度，浮点数，范围为180 ~ -180。
          this.scanResult(scanData)
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },

    // 扫码结果
    scanResult (value, type, isAgency) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })

      if (isAgency) {
        activityApi.qaAgencyScan(value).then(res => {
          this.$toast.clear()
          if (res.data.resultCode === '0') {
            if (res.data.resultData.warrantyInfo) {
              let result = res.data.resultData.warrantyInfo
              this.$router.push({ name: 'quality-assurance-agency-detail', query: { warrantyId: result.warrantyId, deliveryDate: result.deliveryDate } })
            }
          } else {
            this.$notify({
              background: '#1989fa',
              message: res.data.resultMsg,
              className: 'notify-error-msg'
            })
          }
        }).catch(() => {
          this.$toast.clear()
        })
      } else {
        if (type === 'feedback') {
          activityApi.qaFeedbackScan(value).then(res => {
            this.$toast.clear()
            if (res.data.resultCode === '0') {
              this.$router.push({ name: 'quality-assurance-ws-feedback', query: { warrantyId: res.data.resultData.electronicWarrantyInfo.warrantyId, type: 'info' } })
              console.log(res.data)
            } else {
              this.$notify({
                background: '#1989fa',
                message: res.data.resultMsg,
                className: 'notify-error-msg'
              })
            }
          }).catch(() => {
            this.$toast.clear()
          })
        } else {
          activityApi.qaScan(value).then(res => {
            this.$toast.clear()
            if (res.data.resultCode === '0') {
              if (res.data.resultData.electronicWarrantyInfo) {
                let result = res.data.resultData.electronicWarrantyInfo
                if (result.warrantyId) {
                  if (result.warrantyStatus === 1) {
                    let data = JSON.stringify(result)
                    sessionStorage.setItem('codeInfo', data)
                    this.$router.push({ name: 'quality-assurance-ws-info', query: { warrantyStatus: '1', warrantyId: result.warrantyId }, params: { from: 'list' } })
                  } else {
                    this.$router.push({ name: 'quality-assurance-ws-feedback', query: { warrantyId: result.warrantyId } })
                  }
                } else {
                  console.log(result)
                  let data = JSON.stringify(result)
                  sessionStorage.setItem('codeInfo', data)
                  this.$router.push({ name: 'quality-assurance-ws-info' })
                }
              } else if (res.data.resultData.martTrayInfo) {
                this.trayInfo = res.data.resultData.martTrayInfo
                this.showTrayCode = true
                this.trayCodeType = this.trayInfo.trayCode.split('_')[1]
                // let data = JSON.stringify(res.data.resultData.martTrayInfo)
                // sessionStorage.setItem('trayInfo', data)
                // this.$router.push({ name: 'quality-assurance-ws-result', query: { isTrayCode: '1' } })
              }
            } else {
              this.$notify({
                background: '#1989fa',
                message: res.data.resultMsg,
                className: 'notify-error-msg'
              })
            }
          }).catch(() => {
            this.$toast.clear()
          })
        }
      }

      // 测试
      // let data = { activeStatus: 1,
      //   categoryCode: 'WP006',
      //   categoryName: '经济型火花塞',
      //   consumerMobile: '18771705201',
      //   createDate: 1640575729873,
      //   endTime: 1648093087487,
      //   initMileage: 10000.82,
      //   initTime: 1640575729873,
      //   ipAddress: '117.185.81.90',
      //   partId: '21195',
      //   partImageUri: '/upload/62/a5655e39-1af3-4c41-a7f9-2d2bd52177ab.jpg',
      //   partName: '经济型火花塞',
      //   partNo: '0928400617',
      //   partQrCode: '680ad020-2467-431c-806f-e690a4cecd13',
      //   startTime: 1640317087487,
      //   updateDate: 1640588288077,
      //   vinCode: '12345623425235235',
      //   warrantyCode: '16405757298740928400617',
      //   warrantyId: '26',
      //   warrantyStatus: 3,
      //   workshopAddress: '0927',
      //   workshopCode: '0927test',
      //   workshopId: '13287',
      //   workshopName: '0927tesUUUUUUUUUUt',
      //   workshopPerson: '0927test' }

      // let str = JSON.stringify(data)

      // sessionStorage.setItem('codeInfo', str)
      // this.$toast.clear()
      // this.$router.push({ name: 'quality-assurance-ws-info' })
      // console.log(sessionStorage.getItem('codeInfo'))
    }
  }
}
</script>

<style lang="less" scoped>
.loading {
  position: absolute;
  top: 40%;
  left: calc(50vw - 17.5px);
}

.default-tips {
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #888888;
  width: 80%;
  margin: 10px auto;
}

.btn {
  width: 100%;
  text-align: center;
  border-radius: 3px;
  color: white;
  background-color: rgb(17, 114, 129);
}

.search-btn {
  padding: 0px 10px;
}

.scan-btn {
  margin: 10px;
  padding: 12px;
}

.footer {
  width: 100vw;
  background-color: white;
  position: fixed;
  bottom: 0px;
  display: flex;
  justify-content: space-evenly;
}

.qa-list {
  position: relative;
  top: 0px;
  bottom: 60px;

  .tips {
    position: relative;
    top: 46px;
    width: 100%;
    background-color: white;
    text-align: end;
    padding: 5px 0;
  }
}

.qa-item {
  height: auto;
  padding-bottom: 7px;
  background-color: white;
  margin: 10px;
  border-radius: 5px;
  display: flex;

  .item-img {
    width: 100px;
    height: auto;
    margin-right: 10px;

    .button {
      background-color: #00000008;
      width: 100px;
      text-align: center;
      font-size: 11px;
      border: none;
      padding: 4px 5px;
      border-radius: 20px;
      margin-left: 10px;

      .van-icon {
        color: #f1071f;

      }
    }
  }

  img {
    width: 100px;
    height: 100px;
    margin: 10px 10px 0px 10px;
  }

  .item-info-box {
    position: relative;
    width: 100%;

    .item-warrantyCode {
      width: 100%;
      position: absolute;
      top: 2px;
      color: gray;
      font-size: 12px;
      text-align: right;
      right: 5px;
    }
  }

  .item-info {
    font-size: 13px;
    width: 100%;
    position: relative;
    top: 5px;
    height: 90px;
    margin: 10px 10px;
    //line-height: 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .status-1 {
      color: rgb(88, 180, 255);
    }

    .status-2 {
      color: orange;
    }

    .status-3 {
      color: rgb(0, 184, 55);
    }

    .status-4 {
      color: rgb(253, 98, 98);
    }

    .status-5 {
      color: rgb(105, 105, 105);
    }
  }

  .item-mobile {
    font-size: 13px;
  }

  .item-title {
    position: relative;
    font-size: 15px;
    line-height: 20px;
  }

  .item-date {
    font-size: 12px;
    color: rgb(201, 201, 201);
  }

  .item-info-base {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
  }
}

.van-search__action:focus {
  background-color: none;
}

.result-info {
  text-align: center;
  padding: 20px 0 20px 0;

  img {
    width: 80px;
  }

  .result-info-text {
    padding: 20px 0 5px 0;
    font-size: 16px;
  }

  .result-info-text2 {
    border-radius: 5px;
    margin-top: 5px;
    display: inline-block;
    width: 110px;
    color: rgb(26, 164, 245);
    font-size: 13px;
    padding: 4px 0px;
    background-color: rgb(234, 242, 245);
  }
}

.info-item {
  margin: 15px 25px;
  display: flex;
  justify-content: space-between;

  .title {
    color: gray;
    min-width: 95px;
  }
}

.icon-bg {
  display: inline-block;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: #117281;
  font-size: 60px;
  color: white;
}

.trayInfo-pop {
  height: 50%;
  min-height: 400px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.title-pop {
  height: 30px;
  width: 100%;
  line-height: 30px;
  color: white;
  text-align: center;
  background-color: #117281;
}

.tabs {
  position: relative;
  top: 46px;
}

.searchType {
  width: 110px;
  height: 56px;
}

.search-box {
  position: relative;
  top: 46px;
  display: flex;
  width: 100%;
  height: 56px;
}

.search {
  width: calc(100vw - 110px);
}

.noData {
  position: absolute;
  top: 150px;
  color: grey;
  width: 100%;
  text-align: center;
}

.agency-list {
  position: relative;
  top: 45px;
}
</style>
